import { registerTour } from "../tourRegistry";

function getSteps() {
  const totalSteps = 5;
  const stepCounter = (n) => `Step ${n} of ${totalSteps}`;

  return [
    {
      id: 'source-management',
      title: `Source Management <span class="t3-shepherd-step-count">${stepCounter(1)}</span>`,
      text: 'Configure how this donation source connects to your books. Map external fund names to your internal funds, set defaults, and monitor sync status.',
      attachTo: { element: '[data-tour="source-page"]', on: 'top' },
      buttons: [
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'source-sync-status',
      title: `Sync Status <span class="t3-shepherd-step-count">${stepCounter(2)}</span>`,
      text: 'See the current sync status at a glance. For connected sources like Pushpay, this shows when the last sync ran and if there are any issues.',
      attachTo: { element: '[data-tour="source-sync-status"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'source-fund-mapping',
      title: `Fund Mapping <span class="t3-shepherd-step-count">${stepCounter(3)}</span>`,
      text: 'Map each external fund name to your internal fund and income account. When donations come in with an external fund name, T3 Books automatically routes them to the right place.',
      attachTo: { element: '[data-tour="source-fund-mapping"]', on: 'top' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'source-auto-match',
      title: `Auto-Match <span class="t3-shepherd-step-count">${stepCounter(4)}</span>`,
      text: 'Click auto-match to let T3 Books suggest mappings based on similar fund names. Review and confirm each suggestion \u2014 you can always override manually.',
      attachTo: { element: '[data-tour="source-auto-match"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'source-defaults',
      title: `Unmapped Funds & Defaults <span class="t3-shepherd-step-count">${stepCounter(5)}</span>`,
      text: 'Set default accounts for any donations that come in with unmapped fund names. Check the unmapped funds banner (if shown) to see which fund names from recent syncs still need mapping.',
      attachTo: { element: '[data-tour="source-defaults"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Done',
          classes: 't3-shepherd-next-btn',
          action() { this.complete(); },
        },
      ],
    },
  ];
}

registerTour({
  id: 'donationSource',
  pathPattern: new RegExp('^/upkeep/donations/sources/'),
  getSteps,
  label: 'Donation Source Tour',
});
